import React, { useState } from "react";
import "./Login.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { message, Button, Input } from "antd";
import { useSelector, useDispatch } from "react-redux";
import {
  Create_proposal,
  KYC_Status_car,
} from "../../Redux/actions/NumCaration";
import { useHistory } from "react-router-dom";
import axiosInCar from "../../Redux/axios/AxiosInCar";
import { OnOtpSend } from "../../Redux/actions/NumBikeation";

function LoginCar() {
  const dispatch = useDispatch();
  const quotePost = useSelector((state) => state?.cardetail?.quickQuotePost);
  const info1 = useSelector((state) => state?.addressdetail?.info1);
  const store = useSelector((state) => state?.addressdetail?.info2);
  const engine = useSelector((state) => state?.addressdetail?.info3);
  const vechicledetails = useSelector((state) => state?.common?.vahanData);
  const custDetails = useSelector((state) => state?.common?.customerDetail);
  const MakeData = useSelector((state) => state?.cardetail?.carMakeData);
  const carInurId = useSelector((state) => state?.cardetail?.carnum);
  const PrevPolicyD = useSelector(
    (state) => state?.cardetail?.prevpolicydetail
  );
  const info3 = useSelector((state) => state?.addressdetail?.info3);
  const SelectedQQ = useSelector((state) => state?.common?.selectedQuote);
  console.log("SelectedQQ car", SelectedQQ);
  const PrevPolDetails = useSelector(
    (state) => state?.cardetail?.prevpolicydetail
  );
  const [isLoading, setIsLoading] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpflag, setOtpflag] = useState(true);
  const [otpvalid, setOtpvalid] = useState(true);
  const [otp, setOtp] = useState("");
  const [number, setNumber] = useState("91" + carInurId?.phonenumber);
  const [tempotp, setTempotp] = useState("");
  const history = useHistory();
  const [authflagotp, otpauthflagotp] = useState(false);

  const onSendOtp = () => {
    setOtpLoading(true);
    axiosInCar
      .post("v2/car_insurances/otp/send")
      .then((res) => {
        const data = res?.data;
        message.success(res?.data?.message);
        dispatch(OnOtpSend(data));
        setTempotp(otp);
        // alert(otp);
        setOtpvalid(false);
        setOtpflag(false);
        setOtpLoading(false);
      })
      .catch((err) => {
        console.log(err?.response);
        setOtpLoading(false);
        message.error(err?.response?.data?.message);
      });
  };
  const SignInOtp = () => {
    setIsLoading(true);
    // const TwoVehicle = bikeInurId?.bike_insurance_id ? 'bike_insurance':'car_insurance'
    // console.log(TwoVehicle)
    const post = {
      otp: otp,
    };
    axiosInCar
      .post("v2/car_insurances/otp/verify", post)
      .then((res) => {
        console.log(res);
        if (res?.status === 200) {
          message.success(res?.data?.message);
          const insurancePolicyNumber = vechicledetails?.insurance_policy_number
            ? vechicledetails?.insurance_policy_number
            : "";
          const cleanedPolicyNumber = insurancePolicyNumber.replace(/\//g, "");
          // console.log(cleanedPolicyNumber);
          // let currentTP = {
          //   currentThirdPartyPolicyNumber: PrevPolDetails?.previousPolicyNumber,
          //   currentThirdPartyPolicyInsurerCode: PrevPolDetails?.previousInsurerCode,
          //   currentThirdPartyPolicyStartDateTime: moment(SelectedQQ?.previousInsurer?.currentThirdPartyPolicy?.currentThirdPartyPolicyStartDateTime).format("YYYY-MM-DD"),
          //   currentThirdPartyPolicyExpiryDateTime: moment(SelectedQQ?.previousInsurer?.currentThirdPartyPolicy?.currentThirdPartyPolicyExpiryDateTime).format("YYYY-MM-DD"),
          // };
          // if (otp == tempotp) {
          // console.log("logined");

          let post = {
            CKYCId: "40049552589936",
            ILKYCReferenceNumber: "96f394ec-46b1-4dd2-9323-9770033c599d",
            // CKYCId: info1?.CkycNumber,
            // ILKYCReferenceNumber: info1?.il_kyc_ref_no,
            vehicle_core_code: MakeData?.VehicleCoreCode,
            email: store?.Email,
            Address: store?.Address,
            pincode: store?.Pincode,
            previousInsurerCode: quotePost?.previousInsurerCode,
            product_code: SelectedQQ?.product_code,
            previousPolicyNumber: PrevPolicyD?.previousPolicyNumber,
            ckycReferenceNumber: custDetails?.ckycReferenceNumber,
            ckycReferenceDocId: custDetails?.ckycReferenceDocId,
            photo: "",
            dateOfBirth: custDetails?.DateOfBirth,
            gender: custDetails?.gender,
            isVehicleOwner: true,
            NomineeName: store?.Nname,
            relation: store?.Nrelation,
            district: store?.City,
            state: info1?.State,
            city: store?.City,
            licensePlateNumber: quotePost?.licensePlateNumber,
            chasis_number: engine?.Chasis,
            engineNumber: engine?.Engine,
            registrationAuthority: SelectedQQ?.vehicle?.registrationAuthority,
            previousPolicyExpiryDate:
              SelectedQQ?.previousInsurer?.previousPolicyExpiryDate,
            originalPreviousPolicyType:
              SelectedQQ?.previousInsurer?.originalPreviousPolicyType,
            currentThirdPartyPolicy: PrevPolDetails?.currentThirdPartyPolicy,
            firstName: store?.Owner,
            NomineedateOfBirth: store?.Nage,
            insurance_id: carInurId?.car_insurance_id,
            country: "IN",
            returnToInvoice: quotePost?.returnToInvoice,
            consumables: quotePost?.consumables,
            partsDepreciation: quotePost?.partsDepreciation,
            engineProtection: quotePost?.engineProtection,
            roadSideAssistance: quotePost?.roadSideAssistance,
            personalAccident: quotePost?.personalAccident,
            emergencyMedicalExpenses: quotePost?.emergencyMedicalExpenses,
            isPOSP: quotePost?.isPOSP,
            electrical: quotePost?.electrical,
            electricalinsuredamount: quotePost?.electricalinsuredamount,
            nonElectrical: quotePost?.nonElectrical,
            nonElectricalinsuredamount: quotePost?.nonElectricalinsuredamount,
            vehIDV: quotePost?.vehIDV,
            defaultIDV: quotePost?.defaultIDV,
            minimumIDV: quotePost?.minimumIDV,
            maximumIDV: quotePost?.maximumIDV,
            isTPPD: quotePost?.isTPPD,
            rimProtection: quotePost?.rimProtection,
            tyreProtection: quotePost?.tyreProtection,
            personalBelonging: quotePost?.personalBelonging,
            keyAndLockProtect: quotePost?.keyAndLockProtect,
            selfInspection: false,
            financer: info3?.Financer,
            furtherAgreement: info3?.agreementType,
          };
          // console.log(post);
          // `v2/bike_insurances/${bikeInurId?.bike_insurance_id}/insurers/${SelectedQQ?.provider}/proposal`
          axiosInCar
            .post(
              `v2/car_insurances/${carInurId?.car_insurance_id}/insurers/${SelectedQQ?.provider}/proposal`,
              post
            )
            .then((res) => {
              const PropData = res?.data?.data;
              console.log("Final Proposal", PropData);
              if (PropData?.status === "success") {
                let pdata = {
                  data: res.data.data,
                  post: post,
                };
                console.log(pdata);
                dispatch(Create_proposal(pdata));

                if (pdata && SelectedQQ?.provider === "go_digit") {
                  let kycpost = {
                    policyNumber: pdata?.data?.policyNumber,
                  };
                  // v2/car_insurances/{insurance}/insurers/{insurer}/kyc_status

                  axiosInCar
                    .post(
                      `v2/car_insurances/${carInurId?.car_insurance_id}/insurers/${SelectedQQ?.provider}/kyc_status`,
                      kycpost
                    )
                    .then((res) => {
                      // console.log(res)
                      let data = res?.data;
                      dispatch(KYC_Status_car(data));
                      setIsLoading(false);
                      // console.log(data.data.link)
                      if (data?.data?.link) {
                        window.open(data?.data?.link, "_blank");
                      }
                      history.push("/carpay");
                    })
                    .catch((err) => {
                      message.error(err.response.data.error);
                      setIsLoading(false);
                    });
                } else {
                  history.push("/carpay");
                }
              } else if (PropData?.status === "failed") {
                message.error(PropData?.message);
                setIsLoading(false);
              }
            })
            .catch((err) => {
              console.log("error", err.response);
              // message.error(err?.response);
              setIsLoading(false);
            });
          // }
        }
      })
      .catch((err) => {
        console.log(err?.response);
      });
  };
  return (
    <div className="logn-body-rn">
      <div className="login-cont-onl">
        <img
          className="login-cross-i-r"
          src="./Images/numBike/progess/coolicon.svg"
          alt=""
        />
        <div className="login-img-div">
          <img
            className="login-img-i-r imgh"
            src="../../images/logo.png"
            alt=""
          />
        </div>
        <div className="login-inpt-div-o">
          <div className="inpt-div-login">
            <div className="img-div-login-r">
              <img
                src="./Images/numBike/undraw_access_account_re_8spm 1.svg"
                alt=""
              />
            </div>
            <div className="img-div-p-r">
              {otpflag ? (
                <p className="login-div-r-p">Please sign in to continue</p>
              ) : (
                <div className="num-otp-sec">
                  <p className="login-div-r-p">
                    {" "}
                    {`please enter 4 digit OTP sent on ${number}`}
                  </p>
                  <p
                    className="resend-otp-r"
                    onClick={() => {
                      setOtpvalid(true);
                      setOtpflag(true);
                      setTempotp("");
                      setOtp("");
                    }}
                  >
                    Change mobile number
                  </p>
                </div>
              )}
            </div>
          </div>
          <div className="inpt-number-din-r">
            {otpflag ? (
              <PhoneInput
                value={number}
                disabled
                style={{ width: "100%" }}
                country={"in"}
                onChange={(phone) => {
                  setNumber(phone);
                }}
                inputProps={{
                  name: "Mobile Number",
                  required: true,
                  autoFocus: true,
                }}
              />
            ) : (
              <div>
                <Input
                  style={{ width: "100%" }}
                  placeholder="Enter OTP"
                  value={otp}
                  status={authflagotp ? "error" : ""}
                  onChange={(e) => setOtp(e.target.value)}
                />
                {authflagotp && (
                  <div style={{ color: "red" }}>Incorrect OTP.</div>
                )}
                <p
                  onClick={onSendOtp}
                  // onClick={() => {
                  //   if (number.length === 12) {
                  //     setTimeout(() => {
                  //       let otp = Math.floor(100000 + Math.random() * 900000);
                  //       setTempotp(otp);
                  //       alert(otp);
                  //       setOtp("");
                  //     }, [2000]);
                  //   }
                  // }}
                  className="resend-otp-r"
                >
                  Resend OTP
                </p>
              </div>
            )}
            <div className="login-btn1-r">
              {otpvalid ? (
                <div>
                  <Button
                    loading={otpLoading}
                    style={{
                      width: "100%",
                      marginTop: "3%",
                      background: "#273592",
                      color: "#ffff",
                      maxHeight: "42px",
                      minHeight: "42px",
                    }}
                    variant="contained"
                    onClick={onSendOtp}
                  >
                    Sign In with OTP
                  </Button>
                  <Button
                    style={{
                      width: "100%",
                      color: "#273592",
                      borderColor: "#273592",
                      color: "#273592",
                      marginTop: "3%",
                      maxHeight: "42px",
                      minHeight: "42px",
                    }}
                    variant="outlined"
                  >
                    Sign In with Password
                  </Button>
                </div>
              ) : (
                <div>
                  <Button
                    loading={isLoading}
                    style={{
                      width: "100%",
                      background: "#273592",
                      color: "#ffff",
                      marginTop: "3%",
                      maxHeight: "42px",
                      minHeight: "42px",
                    }}
                    variant="contained"
                    onClick={SignInOtp}
                  >
                    Sign In
                  </Button>
                  <Button
                    style={{
                      width: "100%",
                      color: "#273592",
                      borderColor: "#273592",
                      marginTop: "3%",
                      maxHeight: "42px",
                      minHeight: "42px",
                    }}
                    variant="outlined"
                  >
                    Sign In with Password
                  </Button>
                </div>
              )}
            </div>
            <div className="desc-login-r">
              <p className="desc-1p-r">First time user?</p>
              <p className="desc-2p-r">Sign Up</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { LoginCar };
